// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","trendsBlock":"Wvzny","links":"tL2Jx","link":"v_leV DIwTU a8cCT"};